import { RowsPerPageType } from '@node-space/ui-components'

export const MIN_PAGINATION_SIZE: RowsPerPageType = 10
